export { default as withScrollToFooter, ScrollFooterProps } from './withScrollToFooter';
export { default as withIENotSupportedMessage } from './withIENotSupportedMessage';
export { default as withIECompatibility } from './withIECompatibility';



// WEBPACK FOOTER //
// ./packages/platform-common-ui/hoc/index.ts